export enum ActionType {
  Add = 0,
  Edit = 1,
  Delete = 2,
}
